import { NgModule } from 'ng-metadata/core'

import { MenuBarComponent } from './menu-bar.component'

@NgModule({
  declarations: [
    MenuBarComponent
  ],
})

export class MenuBarModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/common/menu-bar/menu-bar.module.ts